<template>
  <div>
    <!-- <div v-if="alarmList" class="uk-flex"> -->
    <div  v-if="true" class="uk-flex uk-flex-between">
      <div class="btns">
        <el-button :type="type === 1 ? 'primary' : ''" @click="changeType(1)">{{ $t('integration.day') }}</el-button>
        <el-button :type="type === 2 ? 'primary' : ''" @click="changeType(2)">{{ $t('integration.month') }}</el-button>
        <el-button :type="type === 3 ? 'primary' : ''" @click="changeType(3)">{{ $t('integration.quarter') }}</el-button>
        <el-button :type="type === 4 ? 'primary' : ''" @click="changeType(4)">{{ $t('integration.year') }}</el-button>

      </div>
      <div style="flex:1;">
        <BarEchart v-if="(dataType ===1 && alarmList.length) || (dataType !== 1 && computedDataList.length)" :chartData="setBarEchartData()"/>
        <el-empty v-else :description="$t('public.no_data')"></el-empty>
      </div>
      <div style="width:40%">
        <div class="mb-5">
          <el-radio-group v-model="dataType" @change="changeDataType">
          <el-radio :label="1">{{ $t('integration.direct_statistics') }}</el-radio>
          <el-radio :label="2"
            :disabled="type === 1">
            {{ $t('integration.year_on_year') }}{{ $t('integration.data') }}
          </el-radio>
          <el-radio :label="3"
            :disabled="type === 1">
            {{ $t('integration.month_on_month') }}{{ $t('integration.data') }}
          </el-radio>
        </el-radio-group>
        </div>
        <div class="mb-10">
          <!-- 直接统计时右边table的显示 -->
          <div v-if="dataType === 1">
            <template v-if="type === 1">
              <el-date-picker
                v-model="timeParams.day"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                :clearable="false"
                @change="changeTime">
              </el-date-picker>
            </template>
            <template v-else-if="type === 2">
              <el-date-picker
                v-model="timeParams.month"
                type="month"
                :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                value-format="yyyy-MM"
                style="width:100%;"
                :clearable="false"
                @change="changeTime">
              </el-date-picker>
            </template>
            <template v-else-if="type === 3">
              <div>
                <el-select v-model="timeParams.quarterYear" style="width:40%;" class="mr-5" @change="changeTime">
                  <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="timeParams.quarter" style="width:55%;" @change="changeTime">
                  <el-option
                    v-for="item in quarterList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <el-select v-model="timeParams.year" style="width:100%;" @change="changeTime">
                  <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </template>
            <el-table
              :data="alarmList"
              border
              style="margin-bottom:20px;margin-top:10px;"
            >
              <el-table-column
                :label="$t('selectMsg.AlarmType')"
                width="130"
                >
                <template  slot-scope="scope">
                  <span>{{ alarmTypeConvert(scope.row.alarmReason) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="numCount"
                :label="$t('integration.number_of_alarms')"
              >
              </el-table-column>
              <el-table-column
                prop="objectCount"
                :label="$t('integration.alarm_object_num')">
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <!-- 同比数据时 -->
            <div v-if="dataType === 2">
              <!-- 月：同比 -->
              <template v-if="type === 2">
                <div>{{$t('integration.statistics')}}
                  <el-date-picker
                    v-model="timeParams.month"
                    type="month"
                    :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                    value-format="yyyy-MM"
                    style="width:80%;"
                    :clearable="false"
                    @change="changeTimeComputed">
                  </el-date-picker>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  <el-select v-model="computedParams.computedYear" style="width:65%;" @change="changeTimeComputedYear">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  {{ computedParams.computedMonth }} {{$t('integration.month')}}
                </div>
              </template>
              <!-- 季度：同比 -->
              <template v-else-if="type === 3">
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-select v-model="timeParams.quarter" style="width:40%;" @change="changeTimeComputed">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  <el-select v-model="computedParams.computedQuarterYear" style="width:30%;" @change="changeTimeComputedYear">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.value === timeParams.quarterYear">
                    </el-option>
                  </el-select>
                  {{ computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                </div>
              </template>

               <!-- 年：同比 -->
              <template v-else>
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="timeParams.year" style="width:80%;" @change="changeTimeComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  {{ computedParams.computedYear }} {{$t('integration.year')}}
                </div>
              </template>

            </div>

            <!-- 环比数据时 -->
            <div v-else>
              <!-- 月：环比 -->
              <template v-if="type === 2">
                <div>{{$t('integration.statistics')}}
                  <el-date-picker
                    v-model="timeParams.month"
                    type="month"
                    :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                    value-format="yyyy-MM"
                    style="width:80%;"
                    :clearable="false"
                    @change="changeTimeComputed">
                  </el-date-picker>
                </div>
                <div class="mt-5">{{$t('integration.month_on_month')}}
                  {{ computedParams.computedYear }} {{$t('integration.year')}}
                  {{ computedParams.computedMonth }} {{$t('integration.month')}}
                </div>
              </template>
              <!-- 季度：环比 -->
              <template v-else-if="type === 3">
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-select v-model="timeParams.quarter" style="width:40%;" @change="changeTimeComputed">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.month_on_month')}}
                  {{ computedParams.computedQuarterYear }} {{$t('integration.year')}}
                  {{ computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                </div>
              </template>
               <!-- 年：环比 -->
                <template v-else>
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="timeParams.year" style="width:80%;" @change="changeTimeComputed">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.month_on_month')}}
                    {{ computedParams.computedYear }} {{$t('integration.year')}}
                  </div>
                </template>
            </div>

            <el-table
                :data="computedDataList"
                :key="isUpdate"
                border
                ref="computedTable"
                style="margin-bottom:20px;margin-top:10px;"
              >
                <el-table-column
                  :label="$t('selectMsg.AlarmType')"
                  width="100"
                  >
                  <template  slot-scope="scope">
                    <span>{{ alarmTypeConvert(scope.row.alarmReason) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in computedDynamicColumns"
                  :key="index"
                >
                  <template slot="header">
                    <span>{{ item }}</span>
                  </template>
                  <el-table-column
                    prop="numCount"
                    :label="$t('integration.number_of_alarms')"
                  >
                  <template  slot-scope="scope">
                    <span v-if="!scope.row.countList[index] || !scope.row.countList[index].numCount"> - </span>
                    <span v-else>
                      {{ scope.row.countList[index].numCount }}
                    </span>
                  </template>
                  </el-table-column>
                  <el-table-column
                    prop="objectCount"
                    :label="$t('integration.alarm_object_num')">
                    <template  slot-scope="scope">
                      <span v-if="!scope.row.countList[index] || !scope.row.countList[index].objectCount"> - </span>
                      <span v-else>
                        {{ scope.row.countList[index].objectCount }}
                      </span>
                    </template>
                  </el-table-column>

                </el-table-column>
              </el-table>

          </div>

        </div>

        <el-button type="primary" style="width:100%" @click="handleDetail">{{ $t('public.btn_view')}}{{ $t('public.detail')}}</el-button>
      </div>
    </div>
    <el-empty v-else :description="$t('public.no_data')"></el-empty>

    <AlarmDetail v-if="isShowDetail" :isShow="isShowDetail"
     :sceneIds="sceneIds"
     @close="isShowDetail = false"/>

  </div>

</template>
<script>
import BarEchart from '@/components/echart/barEchart.vue';
import { getAlarmList } from '@/api/modules/overview.js'
import AlarmDetail from '../alarm/alarmDetail.vue';

export default {
  props: {
    sceneIds: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BarEchart,
    AlarmDetail
  },
  data(){
    return {
      alarmList: [],
      // 选择的数据模式是天/月/季度/年
      type: 1,
      // 选择直接统计/同比/环比
      dataType: 1,
      timeParams: {
        day: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate(),
        month: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1),
        year: new Date().getFullYear(),
        quarterYear: new Date().getFullYear(),
        quarter: 1
      },
      computedParams: {},

      computedDynamicColumns: [],

      computedDataList: [],

      isUpdate: false,

      isShowDetail: false
    }
  },
  computed: {
    yearList(){
      let cur = new Date().getFullYear()
      let arr = []
      for(let i=cur; i>cur-5; i--){
        arr.push({
          value: i,
          label: i + this.$t('integration.year')
        })
      }
      return arr
    },
    // 季度
    quarterList(){
      let arr = []
      for(let i=1; i<5; i++){
        let label = ''
        switch (i){
          case 1:
            label = this.$t('integration.one_quarter')
            break
          case 2:
            label = this.$t('integration.two_quarter')
            break
          case 3:
            label = this.$t('integration.three_quarter')
            break
          case 4:
            label = this.$t('integration.four_quarter')
            break
        }
        arr.push({
          value: i,
          label: label
        })
      }
      return arr
    },

  },
  methods: {
    getData(){
      if(this.sceneIds && this.sceneIds.length){
        this.getAlarm()
      }else{
        this.alarmList = null
      }
    },
    getAlarm(){
      return new Promise((resolve, reject) => {
        let params = {
          scenes: this.sceneIds.join(),
          type: this.type
        }
        if(this.type === 1){
          params.time = this.timeParams.day
        }else if(this.type === 2){
          params.time = this.timeParams.month
        }else if(this.type === 3){
          params.time = this.timeParams.quarterYear + '-' + this.timeParams.quarter
        }else{
          params.time = this.timeParams.year
        }
        console.log('params=', params, this.timeParams)
        getAlarmList(params).then(res => {
          if (res.state.code === 200) {
            this.alarmList = res.result
            resolve();
          }
        })
      })

    },
    setBarEchartData(){
      let data = []
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      if(this.dataType === 1){
        data = this.alarmList
        data.forEach(item => {
          barSeries.xAxis.push(this.alarmTypeConvert(item.alarmReason))
          arr1.push({
            name: this.$t('integration.number_of_alarms'),
            value: item.numCount
          })
          arr2.push({
            name: this.$t('integration.alarm_object_num'),
            value: item.objectCount
          })
        })
        barSeries.series.push(arr1)
        barSeries.series.push(arr2)
      }else{
        data = this.computedDataList
        barSeries.xAxis = this.computedDynamicColumns
        data.forEach(item => {
          let arr = []
          arr.push(item.countList[0] ? item.countList[0].numCount : 0)
          arr.push(item.countList[1] ? item.countList[1].numCount : 0)

          barSeries.series.push(arr)
        })
      }
      console.log('barSeries=', barSeries)

      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        },
        // 提示窗
            // tooltip: {
            //   trigger: 'axis',
            //   axisPointer: {
            //     animation: false
            //   },
            //   formatter: params => {
            //     console.log('params=',params)
            //     params = params[0]

            //     if (params.value[1] === '---') {
            //       return ''
            //     }
            //     const no = params.data.no
            //     return (
            //       $t('public.time')
            //     )
            //   }
            // },
      }
    },
    // 选择的数据模式改变
    changeType(type){
      this.type = type
      if(this.dataType === 1){
        this.getAlarm()
      }else{
        this.changeDataType()
      }
    },
    changeTime(){
      this.getAlarm()
    },
    // 直接统计/同比/环比改变
    async changeDataType(){
      if(this.dataType == 2 ){
        this.computedParams = JSON.parse(JSON.stringify(this.timeParams))

        if(this.type ===2){
          this.$set(this.computedParams, 'computedYear', parseInt(this.computedParams.month.split('-')[0]) - 1)
          this.$set(this.computedParams, 'computedMonth', this.computedParams.month.split('-')[1])
        }else if(this.type === 3){
          this.$set(this.computedParams, 'computedQuarterYear', this.computedParams.quarterYear - 1)
          this.$set(this.computedParams, 'computedQuarter', this.computedParams.quarter)
        }else{
          this.$set(this.computedParams, 'computedYear', this.computedParams.year - 1)
        }

      }else if(this.dataType == 3){
        this.computedParams = JSON.parse(JSON.stringify(this.timeParams))
        if(this.type ===2){
          // 如果是1月环比，就要和上一年的12月比
          if(parseInt(this.computedParams.month.split('-')[1]) ===  1){
            this.$set(this.computedParams, 'computedYear', parseInt(this.computedParams.month.split('-')[0]) - 1)
            this.$set(this.computedParams, 'computedMonth', 12)
          }else{
            this.$set(this.computedParams, 'computedYear', this.computedParams.month.split('-')[0])
            this.$set(this.computedParams, 'computedMonth', parseInt(this.computedParams.month.split('-')[1]) - 1)
          }

        }else if(this.type === 3){
          // 如果是第一季度环比，就是和上一年的第4季度比
          if(this.computedParams.quarter == 1){
            this.$set(this.computedParams, 'computedQuarterYear', this.computedParams.quarterYear - 1)
            this.$set(this.computedParams, 'computedQuarter', 4)
          }else{
            this.$set(this.computedParams, 'computedQuarterYear', this.computedParams.quarterYear)
            this.$set(this.computedParams, 'computedQuarter', this.computedParams.quarter - 1)
          }

        }else{
          this.$set(this.computedParams, 'computedYear', this.computedParams.year - 1)
        }
      }
      await this.getAlarm()
      this.getComputedAlarm()
    },
    // 获取对比的另一个数据
    getComputedAlarm(){
      this.computedDynamicColumns = []
      this.computedDataList = []
        let params = {
          scenes: this.sceneIds.join(),
          type: this.type
        }
        if(this.type === 2){
          params.time = this.computedParams.computedYear + '-' + this.computedParams.computedMonth

          this.computedDynamicColumns.push(`${this.timeParams.month.split('-')[0]}${this.$t('integration.year')}${this.timeParams.month.split('-')[1]}${this.$t('integration.month')}`)
          this.computedDynamicColumns.push(`${this.computedParams.computedYear}${this.$t('integration.year')}${this.computedParams.computedMonth}${this.$t('integration.month')}`)

        }else if(this.type === 3){ // 季度
          params.time = this.computedParams.computedQuarterYear + '-' + this.computedParams.computedQuarter

          let label1 = ''
          switch (this.timeParams.quarter){
            case 1:
              label1 = this.$t('integration.one_quarter')
              break
            case 2:
              label1 = this.$t('integration.two_quarter')
              break
            case 3:
              label1 = this.$t('integration.three_quarter')
              break
            case 4:
              label1 = this.$t('integration.four_quarter')
              break
          }
          let label2 = ''
          switch (this.computedParams.computedQuarter){
            case 1:
              label2 = this.$t('integration.one_quarter')
              break
            case 2:
              label2 = this.$t('integration.two_quarter')
              break
            case 3:
              label2 = this.$t('integration.three_quarter')
              break
            case 4:
              label2 = this.$t('integration.four_quarter')
              break
          }
          this.computedDynamicColumns.push(`${this.timeParams.quarterYear}${this.$t('integration.year')} ${label1}`)
          this.computedDynamicColumns.push(`${this.computedParams.computedQuarterYear}${this.$t('integration.year')} ${label2}`)

        }else{
          params.time = this.computedParams.computedYear

           this.computedDynamicColumns.push(`${this.timeParams.year}${this.$t('integration.year')}`)
          this.computedDynamicColumns.push(`${this.computedParams.computedYear}${this.$t('integration.year')}`)
        }
        console.log('params=', params, this.computedParams)
        console.log('computedDynamicColumns=================', this.computedDynamicColumns)
          // this.$refs.computedTable.doLayout()
          this.isUpdate = !this.isUpdate

        getAlarmList(params).then(res => {
          if (res.state.code === 200) {
            // this.alarmList = res.result

            // 整合对比的两个table数据
            if(this.alarmList.length){
              this.alarmList.forEach(item => {
                this.computedDataList.push({
                  alarmReason: item.alarmReason,
                  countList: [{...item}]
                })
              })

              res.result.forEach(item2 => {
                let index = this.computedDataList.findIndex(_ => _.alarmReason === item2.alarmReason)
                if(index === -1){
                  this.computedDataList.push({
                    alarmReason: item2.alarmReason,
                    countList: [{}, {...item2}]
                  })
                }else{
                  this.computedDataList[index].countList.push({...item2})
                }

              })
            }else{
              res.result.forEach(item2 => {
                this.computedDataList.push({
                    alarmReason: item2.alarmReason,
                    countList: [{}, {...item2}]
                  })
              })
            }


            console.log('computedDataList=',this.computedDataList)

          }
        })
    },

    // 同比时第一行统计选择改变时
    changeTimeComputed(){
      this.changeDataType()
    },

    // 同比时第二行选择改变时
    async changeTimeComputedYear(){
      console.log('changeTimeComputedYear=================', this.computedParams.computedYear)
       await this.getAlarm()
        this.getComputedAlarm()
    },
    // 查看详情
    handleDetail(){
      this.isShowDetail = true
    },


    alarmTypeConvert(type){
      switch(type){
        case 0:
          return this.$t('public.ex_conn')
        case 1:
          return this.$t('public.ex_data')
        case 2:
          return this.$t('public.ex_power')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btns{
  width: 100px;
  .el-button{
    width: 80px;
    margin: 5px;
  }
}
</style>
